export default __webpack_public_path__ + "static/media/movie-episode-1.dce12a18.jpg";